module.exports = __webpack_public_path__ + "img/bgc7.348362f7.png";